import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subscription } from '../models';
import { BASE_URL } from '@teamfoster/sdk/ssr';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionsService {
  private http = inject(HttpClient);
  private BASE_URL = inject(BASE_URL, { optional: true })!;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  getSubscriptions(token: string) {
    return this.http.get<Subscription[]>(`${this.BASE_URL}api/my-rova/notifications/subscriptions?token=${token}`);
  }

  saveSubscription(subscription: Subscription, koad: string) {
    return this.http.post<Subscription>(`${this.BASE_URL}api/my-rova/notifications/subscription?koad=${koad}`, subscription);
  }

  saveSubscriptions(subscriptions: Subscription[], koad: string, token: string) {
    return this.http.post<Subscription[]>(
      `${this.BASE_URL}api/my-rova/notifications/subscriptions?koad=${koad}&token=${token}`,
      subscriptions
    );
  }

  deleteSubscription(id: number, token: string) {
    return this.http.delete<Subscription>(`${this.BASE_URL}api/my-rova/notifications/subscriptions/${id}?token=${token}`);
  }

  deleteSubscriptions(token: string) {
    return this.http.delete<any>(`${this.BASE_URL}api/my-rova/notifications/subscriptions?token=${token}`);
  }
}
